<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span 4
      h1 Relación, vínculo y comunicación

    figure.mb-4(data-aos="zoom-in")
      img.img-fluid(src="@/assets/curso/temas/tema4/img1.jpg" alt="Imagen decorativa")
    .row.justify-content-center.mb-4
          .col-lg-1.d-none.d-lg-block
            figure(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema4/img2.svg" alt="Icono 1")
          .col-lg-11
            p.mb-0(data-aos="fade-left") La relación en el contexto de la atención en salud se construye a partir del encuentro entre personas que interactúan desde sus roles, experiencias, emociones y expectativas. No se trata únicamente de un contacto funcional, sino de un proceso interpersonal en el que influyen la actitud, el respeto y la disposición para comprender al otro como un ser humano integral.
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-4
        .tarjeta--celeste.color-primario.p-2
          p.text-center.mb-0 A continuación, la explicación de ambos procesos:
    
    .row.justify-content-center.align-items-center
      .col-lg-10
        PasosA.color-acento-contenido.mb-5(tipo="n")
          .row(titulo="")
            .col-lg-10.mb-4.mb-md-0
              h5  Vínculo 
              p.mb-0  Surge cuando esta relación se fortalece mediante la confianza, la empatía y el reconocimiento mutuo. En el ámbito de la salud, el vínculo entre el personal de salud, el paciente y su familia favorece la adherencia a los tratamientos, la participación activa en las decisiones y la percepción de una atención digna y humanizada. Un vínculo sólido permite que la persona se sienta escuchada, comprendida y acompañada durante su proceso de atención.
            .col-lg-2.d-none.d-lg-block
              figure.mb-4(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img3.svg" alt="Imagen decorativa")
          .row(titulo="")
            .col-lg-2.d-none.d-lg-block
              figure.mb-4(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img4.svg" alt="Imagen decorativa")
            .col-lg-10.mb-4.mb-md-0
              h5  Comunicación 
              p.mb-0  Es el eje que articula la relación y el vínculo. A través de una comunicación clara, asertiva y empática se expresan pensamientos, emociones e información relevante, se aclaran dudas y se reducen temores. Cuando la comunicación es efectiva, se fortalecen las relaciones interpersonales, se consolida el vínculo terapéutico y se promueve una atención centrada en la persona, la familia y el contexto, pilares fundamentales de la humanización en salud. 
            
    separador
    #t_4_1.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  4.1	Manejo de emociones
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-7.order-2.order-lg-1
        .cajon.color-secundario.p-4.mb-4
          p.mb-0 Como bien lo describe Raventós Torras, “la humanización es cuestión de actitud”; es decir, que para abordar la humanización es necesario estar dispuesto a entenderla para construirla y promoverla. En ello es fundamental partir de un análisis interno para generar cambios al exterior.
        .row
          .col-lg-10
            p.mb-0 Las emociones hacen parte fundamental del ser humano, de manera individual y social. Investigadores han estudiado la relación entre las emociones o sentimientos con sensaciones físicas.
          .col-lg-2.d-lg-block.d-none
            figure.mb-4(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema4/img6.svg" alt="Imagen decorativa")

      .col-lg-5.col-8.order-1.order-lg-2
        figure.mb-4(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema4/img5.png" alt="Imagen decorativa")
    
    .tarjeta.color-acento-botones.p-3.mb-5(data-aos="fade-right")
      .row.justify-content-around.align-items-center
        .col-3.col-sm-2.col-lg-1
          img(src="@/assets/curso/temas/tema4/img7.svg")
        .col
          .row.justify-content-between.align-items-center
            .col.mb-sm-0.mb-4
              h3.mb-1 Respuestas emocionales
              p Diversos investigadores probaron las respuestas emocionales en cientos de sujetos y luego crearon mapas que identifican ubicaciones en el cuerpo donde las emociones causan cambios físicos.
            .col-sm-auto
              a.boton.color-acento-botones(:href="('https://www.youtube.com/watch?v=cZP_I6NkQb4')" target="_blank" type="application/pdf")
                span Abrir video
                i.fas.fa-file-download

    .row.tarjeta--BMG5.justify-content-center.align-items-center.mb-4
      .col-lg-5
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema4/img8.png" alt="Imagen decorativa" style="margin-left: -12px;")
      .col-lg-7
        .row
          .col-2.d-lg-block.d-none
            figure.mb-4(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema4/img9.svg" alt="Imagen decorativa")

        p.mb-0 Tradicionalmente se ha reconocido la importancia del control de las acciones, asociando la inteligencia con la capacidad lógica, el razonamiento lingüístico o lógico-matemático y vinculándola, en muchos casos, con el éxito personal y profesional. La inteligencia, entendida como la capacidad de relacionar pensamientos para generar nuevos aprendizajes, se construye a partir de la herencia y del entorno o contexto cultural. No obstante, en los últimos años ha cobrado relevancia el manejo de las emociones, reconociéndose como otro tipo de inteligencia: la inteligencia emocional, la cual enfatiza la capacidad de comprenderse y regularse a sí mismo, así como de relacionarse de manera adecuada con los demás.
    p.mb-4 Para complementar el tema relacionado con las emociones, se invita a que ingrese al siguiente video que trata sobre la inteligencia emocional según Daniel Goleman:
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-12
        figure(data-aos="zoom-in")
          .video
            iframe(width="1401" height="788" src="https://www.youtube.com/embed/XcehU-LnvJw" title="Inteligencia emocional" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen)
            
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-6
        p.mb-0 Las habilidades que ayudan a desarrollar las aptitudes personales y sociales son:
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        .titulo-sexto.color-primario(data-aos="fade-left")
          h5 Figura 2.
          span Inteligencia emocional
    .row.justify-content-center.align-items-center
      .col-lg-10.movil(data-aos="fade-left")
        figure
          img(src='@/assets/curso/temas/tema4/img10_1.svg', alt='Figura 2 que explica la inteligencia emocional como el equilibrio entre la actitud personal y la actitud social, mostrando cómo, a partir del reconocimiento y manejo de las emociones, se desarrollan acciones y habilidades aplicadas en la vida personal y en la relación con los demás, como la autorregulación, la empatía, la comunicación, la adaptabilidad y el trabajo colaborativo, entre otras.')
      .col-lg-10.desktop(data-aos="fade-left")
        figure
          img(src='@/assets/curso/temas/tema4/img10.svg', alt='Figura 2 que explica la inteligencia emocional como el equilibrio entre la actitud personal y la actitud social, mostrando cómo, a partir del reconocimiento y manejo de las emociones, se desarrollan acciones y habilidades aplicadas en la vida personal y en la relación con los demás, como la autorregulación, la empatía, la comunicación, la adaptabilidad y el trabajo colaborativo, entre otras.')

    
    separador
    #t_4_2.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  4.2	Comunicación asertiva y efectiva

    .row.justify-content-center.align-items-center.mb-4
      .col-lg-3.col-6.mb-4.mb-lg-0
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema4/img11.png" alt="Icono 1")
      .col-lg-9.mb-4.mb-lg-0
        .row.justify-content-center.mb-3
          .col-lg-2.d-none.d-lg-block
            figure(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema4/img12.svg" alt="Icono 1")
          .col-lg-10
            p.mb-0(data-aos="fade-left") Es fundamental fortalecer las habilidades sociales, entre ellas la comprensión de la importancia de la comunicación en la atención en salud. El conocimiento de los elementos de la comunicación, los medios, las barreras y las habilidades comunicativas, favorece el desarrollo de una comunicación asertiva y efectiva por parte del talento humano en salud.
        .cajon.color-secundario.p-4.mb-4
          p.mb-0(data-aos="fade-left") La comunicación depende en gran medida de la calidad de la relación interpersonal y va más allá del lenguaje oral o de la simple transmisión de información. Incluye aspectos como el modo de vestir, los gestos, las expresiones faciales, el tono de voz e incluso el silencio, los cuales permiten expresar emociones como agrado, desagrado, alegría o tristeza. En este sentido, la comunicación integra el conocimiento del comportamiento humano para comprender de manera integral el acto comunicativo.
        p.mb-0 Entendida como un intercambio de información, ideas y emociones, la comunicación implica una relación interpersonal en la que el mensaje debe ser comprendido, interpretado y respondido. Este proceso es esencial para establecer vínculos, generar confianza y favorecer interacciones efectivas y humanizadas en los escenarios de atención en salud.

    .row.justify-content-center.align-items-center.mb-4
      .col-lg-7
        .titulo.mb-4(data-aos="fade-left")
          img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
          h5 Destrezas
        p En principio, la comunicación es de carácter interpersonal, pero también se puede presentar la comunicación intragrupal u organizacional; por lo tanto, se hace necesario destrezas de comunicación. Entre ellas la más importante es contar con una actitud positiva y tener claro las palabras y acciones que se emitirán.
        .col-lg-7
        .titulo.mb-4(data-aos="fade-left")
          img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
          h5 Elementos de la comunicación
        p.mb-0 La comunicación siempre incluye los siguientes elementos, que interactúan entre sí para realizar una comunicación efectiva, si falla alguno de los elementos falla la acción comunicativa:

      .col-lg-5.col-6.mb-4.mb-lg-0.order-1.order-lg-2
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema4/img13.jpg" alt="Icono 1")
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        .titulo-sexto.color-primario(data-aos="fade-left")
          h5 Figura 3.
          span Elementos de la comunicación
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10.movil(data-aos="fade-left")
        figure
          img(src='@/assets/curso/temas/tema4/img14_1.svg', alt='Figura 3 que relaciona los elementos que están presentes en la comunicación, los cuales parten del emisor quien origina la información y la organiza en un mensaje. Este mensaje se transmite a través de un canal, que puede ser verbal, escrito o no verbal, utilizando un código común que permite su comprensión, hasta llegar al receptor, quien interpreta el contenido y le da significado.')
      .col-lg-10.desktop(data-aos="fade-left")
        figure
          img(src='@/assets/curso/temas/tema4/img14.svg', alt='Figura 3 que relaciona los elementos que están presentes en la comunicación, los cuales parten del emisor quien origina la información y la organiza en un mensaje. Este mensaje se transmite a través de un canal, que puede ser verbal, escrito o no verbal, utilizando un código común que permite su comprensión, hasta llegar al receptor, quien interpreta el contenido y le da significado.')

    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        p.mb-0 En el área de la salud, brindar una atención humanizada parte desde la actitud y aptitud del personal de salud-paciente y familia.
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        .bloque-texto-c.tarjeta--celeste.p-4
          i.fas.fa-quote-left
          p.text-bold.ms-2.mb-0 No importa cuán sofisticada sea la tecnología de salud recibida, la salud se alivia con tres simples elementos humanos: compasión, contacto y conversación. – Daniel Patrick Sulmasy
          br
          span - Daniel Patrick Sulmasy
          .d-flex.justify-content-end.align-items-center(style="margin-top:-35px")
              i.fas.fa-quote-right

    .row.justify-content-center.align-items-center.mb-5
      .col-lg-10
        p.mb-0 Es importante conocer las habilidades y barreras en la comunicación efectiva. Por consiguiente, se detallan en primera instancia las habilidades:
    
    .tarjeta--BMG4.p-5.mb-4
      .tarjeta.tarjeta--gris.p-4
        PasosB.color-acento-contenido
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img15.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Reflexión
              p.mb-0 Cuando la persona emisora estructura el contenido del mensaje adecuándose a las circunstancias concretas del receptor, al entorno y buscando el canal de transmisión más adecuado.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img16.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Hablar y escribir
              p.mb-0 Habilidades exclusivas de la persona emisora, qué mensaje desea transmitir de forma oral o escrita.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img17.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Intereses
              p.mb-0 Habilidad de la persona emisora y receptora. Debe haber interés por comunicar de la persona emisora e interés de escuchar de la persona receptora.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img18.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Nivel de conocimientos
              p.mb-0 Tanto la persona emisora y la persona receptora, deben tener unos conocimientos similares para producir el mensaje y que este sea entendido.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img19.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Sistema sociocultural
              p.mb-0 Si la persona emisora y la persona receptora pertenecen a grupos sociales y culturas muy diferentes, puede haber complicaciones para entender el mensaje.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img20.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Personalidad
              p.mb-0 Las características personales son importantes en ambos extremos. La persona emisora y la persona receptora deben conocerse para ubicar el mensaje en su sentido exacto.
          .row(titulo="")
            .col-lg-6.col-10.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema4/img21.jpg" alt="Imagen decorativa")
            .col-lg-6.mb-4.mb-md-0
              h5 Lectura y escucha
              p.mb-0 Habilidades propias de la persona receptora para poder asimilar y comprender el mensaje, bien sea escrito u oral.
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        p.mb-0 Y como segunda instancia, se relacionan de igual o mayor importancia, las barreras:
    
    SlyderF.mb-5(columnas="col-lg-6 col-xl-4")
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img22.svg' alt='AvatarTop')
        h5.text-center Filtración
        p.text-center Hace referencia a la manipulación de la información con la finalidad de que esta sea vista de manera favorable por el receptor.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img23.svg' alt='AvatarTop')
        h5.text-center Percepción selectiva
        p.text-center Surge cuando los receptores, durante el proceso de comunicación, reciben el mensaje de manera selectiva y lo decodifican.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img24.svg' alt='AvatarTop')
        h5.text-center Defensa
        p.text-center Hace referencia a la acción-reacción; el sentimiento de amenaza hacia el individuo produce un resultado.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img25.svg' alt='AvatarTop')
        h5.text-center Lenguaje
        p.text-center El significado de las palabras no está en la palabra, está en el ser mismo (de acuerdo con: la edad, la educación y los antecedentes culturales).
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img26.svg' alt='AvatarTop')
        h5.text-center Deformación
        p.text-center Es un problema semántico influenciado por la forma de pensar o la crianza.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img27.svg' alt='AvatarTop')
        h5.text-center Sobrecarga
        p.text-center Tiene que ver con recibir demasiada información.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img28.svg' alt='AvatarTop')
        h5.text-center Sincronización
        p.text-center Coordinación entre el tiempo y la información.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img29.svg' alt='AvatarTop')
        h5.text-center Falta de aceptación
        p.text-center Negación.
      .tarjeta.color-primario.p-4
        .row.justify-content-center.mb-3
          .col-6
            img(src='@/assets/curso/temas/tema4/img30.svg' alt='AvatarTop')
        h5.text-center Cortocircuito
        p.text-centerOcurre Cuando se salta algún nivel estructural de la organización.

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Comunicación efectiva en salud
    p.mb-4 La comunicación tiene diversos canales que pueden verse afectados, a su vez, por múltiples factores mencionados anteriormente como el contexto, las personas, las emociones, entre otros. De allí la importancia de reflexionar en acciones propias que aporten a la comunicación efectiva en ámbitos de la salud. 

    .tarjeta.color-acento-botones.p-3.mb-5(data-aos="fade-right")
      .row.justify-content-around.align-items-center
        .col-3.col-sm-2.col-lg-1
          img(src="@/assets/curso/temas/tema4/img31.svg")
        .col
          .row.justify-content-between.align-items-center
            .col.mb-sm-0.mb-4
              h3.mb-1 Hacia una comunicación efectiva y humanista en ámbitos de salud
              p Ingresando al siguiente artículo, le ayudará en la reflexión, reconociendo algunas situaciones y estrategias de uso práctico en el desempeño profesional o campo de acción.
            .col-sm-auto
              a.boton.color-acento-botones(:href="obtenerLink('/downloads/Hacia_una_comunicacion_efectiva.pdf')" target="_blank" type="application/pdf")
                span Descargar
                i.fas.fa-file-download
      
</template>
<script>
export default {
  name: 'Tema4',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
